import { Component, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { PACT, SACT, LACT } from './config';
import { FitmentsContextualActionComponent } from './contextual-action.component';


@Component({
  moduleId: module.id,
  selector: 'loaded-product-action',
  templateUrl: 'loaded-product-action.component.html',
  styleUrls: ['contextual-action.component.scss'],
})
export class LoadedProductActionComponent extends FitmentsContextualActionComponent {

  @HostBinding('class.loaded-product-action')
  hostClass: boolean = true;

  @Output() removeClicked = new EventEmitter();

  primaryActions = PACT;
}
